import { useEffect, useState } from "react";
import { Icon } from "@/components/icons";
import { ToolbarPopover } from "@/components/ToolbarPopover";
import { applyTheme, getTheme, setTheme, type Theme } from "@/lib/theme";

export function AppearanceToggle() {
  const [theme, choose] = useState<Theme>(getTheme);
  useEffect(() => {
    const sync = (event: StorageEvent) => {
      if (event.key !== "celia-theme" && event.key !== null) return;
      const next = getTheme(); choose(next); applyTheme(next);
    };
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);
  return <ToolbarPopover label="Appearance" triggerClass="icon-button appearance-trigger" triggerContent={<Icon name="appearance" />} menu role="menu">
    <p className="px-2 py-1 text-xs text-muted">Appearance</p>
    {([["system", "Auto"], ["light", "Light"], ["dark", "Dark"]] as const).map(([value, label]) => <button key={value} type="button" role="menuitemradio" aria-checked={theme === value}
      className="flex w-full items-center justify-between rounded-lg px-2 py-2 text-sm text-ink hover:bg-raise"
      onClick={() => { setTheme(value); choose(value); }}>{label}{theme === value && <Icon name="check" size={16} />}</button>)}
  </ToolbarPopover>;
}
